"use strict";
import React from 'react'
import defaultImage from '../images/logo/logo-128.png'
function setCategoryImage(image, account) {
    return image ? image :
        account && account.logo ?
            account.logo : defaultImage
};

export default setCategoryImage;